import { render } from "./Comunicacao.vue?vue&type=template&id=15a82e3a&scoped=true"
import script from "./Comunicacao.vue?vue&type=script&lang=js"
export * from "./Comunicacao.vue?vue&type=script&lang=js"

import "./Comunicacao.vue?vue&type=style&index=0&id=15a82e3a&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a82e3a"]])

export default __exports__